import $ from 'jquery';
import header from '../../../views/partials/header/header';
import menu from '../../../views/partials/menu/menu';
// import AOS from 'aos';

export default {
    init() {

    },

    finalize() {
        header();
        menu();
        // AOS.init();
        $(window).on('scroll', function () {
            var offset = $('.visual').height() - 470;
            if ($(this).scrollTop() >= offset) {
                $('#hamburger-toggle').addClass('dark');
                $('.menu-desktop').addClass('dark');
                $('.fixed-bar').addClass('opacity-100');
            } else {
                $('#hamburger-toggle').removeClass('dark');
                $('.menu-desktop').removeClass('dark');
                $('.fixed-bar').removeClass('opacity-100');
            }
        });

    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js